import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const BalancerIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <g id="Layer_2" data-name="Layer 2">
   <g id="Layer_7_copy_7" data-name="Layer 7 copy 7">
    <g id="_88" data-name=" 88">
     <path d="M4.11,15.6c3,0,4.98-3.12,3.69-5.84l-3.08-6.48h2.42c-.16-.54-.16-1.11,0-1.65H1.55c-.46,0-.82.37-.82.82s.37.82.82.82h1.95L.42,9.77c-1.28,2.71.69,5.83,3.69,5.83ZM1.47,10.27l2.64-5.56,2.64,5.56c.06.13.12.27.16.41-.53-.19-1.4-.27-2.8-.27s-2.25.07-2.79.26c.04-.14.1-.27.16-.4Z" />
     <path d="M15.28,3.28l-3.08,6.49c-1.29,2.71.69,5.84,3.69,5.84s4.98-3.12,3.69-5.84l-3.08-6.49h1.95c.46,0,.82-.37.82-.82s-.37-.82-.82-.82h-5.6c.16.54.16,1.11,0,1.65h2.42ZM18.69,10.67c-.53-.19-1.4-.27-2.8-.27s-2.26.07-2.79.26c.04-.14.09-.27.16-.4l2.64-5.56,2.64,5.56c.06.13.11.27.16.41Z" />
     <path d="M19.16,18.34h-8.34V5.31c-.54.16-1.11.16-1.65,0v13.03H.84c-.46-.01-.83.35-.84.8s.35.83.8.84h18.35c.46.01.83-.35.84-.8s-.35-.83-.8-.84h-.04,0Z" />
     <circle cx="10" cy="2.45" r="2.44" />
    </g>
   </g>
  </g>
 </svg>,
 "Balancer"
);
